import type { CatalogDetail } from '@/types'

export const CATALOG_DETAILS: Record<string, CatalogDetail> = {
  // 零售金融板块
  'retail-customer': {
    id: 'retail-customer',
    name: '代发客群资金交易明细主题',
    description: '代发客户工资流水、余额变动、资金留存等交易明细分析，包含客户信息、客群标签、单位信息及工资资金指标',
    tableCount: 3,
    recordCount: '80 万+',
    updateFrequency: 'T+1 每日更新',
    owner: '零售金融部',
    contact: '张三 (分机：8001)',
    fields: [
      {
        id: 'c1',
        name: '客户号',
        code: 'CUST_NO',
        definition: '代发客户在银行系统中的唯一标识',
        caliber: '10 位数字，银行内部统一分配',
        dataType: 'string',
        length: 10,
        nullable: false,
        quality: {
          completeness: 99.9,
          accuracy: 99.8,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['1001000001', '1001000002'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.CUST_INFO',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c2',
        name: '客户姓名',
        code: 'CUST_NAME',
        definition: '代发客户的真实姓名，与身份证件一致',
        caliber: '与客户有效身份证件上的姓名完全一致',
        dataType: 'string',
        length: 50,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.9,
          timeliness: 99.0,
          issues: ['部分客户姓名含生僻字显示异常']
        },
        sampleData: ['陈明华', '林小雨'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.CUST_INFO',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c3',
        name: '是否代发新客活动打标客群',
        code: 'IS_NEW_PAYROLL_CUST',
        definition: '标识该客户是否属于代发新客活动打标客群',
        caliber: '是/否，根据代发新客活动规则自动打标',
        dataType: 'string',
        length: 2,
        nullable: false,
        quality: {
          completeness: 98.0,
          accuracy: 97.0,
          timeliness: 95.0,
          issues: ['部分历史客户活动打标数据延迟']
        },
        sampleData: ['是', '否'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.CUST_LABEL',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c4',
        name: '是否老友活动达标客群',
        code: 'IS_OLD_FRIEND_CUST',
        definition: '标识该客户是否属于老友活动达标客群',
        caliber: '是/否，根据老友活动规则自动判定',
        dataType: 'string',
        length: 2,
        nullable: false,
        quality: {
          completeness: 98.0,
          accuracy: 97.5,
          timeliness: 95.0,
          issues: []
        },
        sampleData: ['是', '否'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.CUST_LABEL',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c5',
        name: '是否已退休',
        code: 'IS_RETIRED',
        definition: '标识该客户是否已退休',
        caliber: '是/否，根据客户年龄及职业状态判定',
        dataType: 'string',
        length: 2,
        nullable: false,
        quality: {
          completeness: 95.0,
          accuracy: 96.0,
          timeliness: 95.0,
          issues: ['部分客户职业状态未更新']
        },
        sampleData: ['是', '否'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.CUST_LABEL',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c6',
        name: '代发渠道',
        code: 'PAYROLL_CHANNEL',
        definition: '代发工资的业务渠道',
        caliber: '企业网银/手机银行/柜面等',
        dataType: 'string',
        length: 20,
        nullable: false,
        quality: {
          completeness: 99.5,
          accuracy: 99.0,
          timeliness: 98.0,
          issues: []
        },
        sampleData: ['企业网银', '手机银行', '柜面'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.UNIT_INFO',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c7',
        name: '代发单位名称',
        code: 'PAYROLL_UNIT_NAME',
        definition: '为该客户代发工资的单位全称',
        caliber: '与单位营业执照名称一致',
        dataType: 'string',
        length: 200,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.8,
          timeliness: 98.0,
          issues: ['企业更名后存在少量未及时更新']
        },
        sampleData: ['广州天河科技有限公司', '深圳南山区投资有限公司'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.UNIT_INFO',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c8',
        name: '代发支行名称',
        code: 'PAYROLL_SUBBRANCH',
        definition: '代发业务所属支行名称',
        caliber: '支行标准名称',
        dataType: 'string',
        length: 50,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.9,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['东风支行', '广州芳村支行', '逢源支行'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.UNIT_INFO',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c9',
        name: '所属分行名称',
        code: 'BRANCH_NAME',
        definition: '代发业务所属分行名称',
        caliber: '分行标准名称',
        dataType: 'string',
        length: 50,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['广州分行', '佛山分行', '东莞分行', '惠州分行'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.UNIT_INFO',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c10',
        name: '首次代发日期',
        code: 'FIRST_PAYROLL_DATE',
        definition: '该客户首次收到代发工资的日期',
        caliber: '格式：YYYY-MM-DD，首次代发交易入账日期',
        dataType: 'date',
        nullable: false,
        quality: {
          completeness: 99.5,
          accuracy: 99.8,
          timeliness: 98.0,
          issues: ['少量历史数据首次代发日期未记录']
        },
        sampleData: ['2025-03-15', '2024-08-20', '2020-01-10'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.UNIT_INFO',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c11',
        name: '查询年月',
        code: 'QUERY_YYYYMM',
        definition: '代发数据所属的统计年月',
        caliber: '格式：YYYY-MM，如 2026-05 表示 2026 年 5 月',
        dataType: 'string',
        length: 7,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['2026-05', '2026-04'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.STAT_DATA',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c12',
        name: '当月累计代发工资金额',
        code: 'MONTHLY_PAYROLL_AMT',
        definition: '该客户当月累计收到的代发工资总额',
        caliber: '单位：元，保留两位小数。当月所有代发工资交易金额汇总',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.9,
          timeliness: 98.0,
          issues: []
        },
        sampleData: ['15800.00', '12500.00', '8200.00'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.STAT_DATA',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c13',
        name: '当月累计转出金额',
        code: 'MONTHLY_TRANSFER_OUT_AMT',
        definition: '该客户当月累计转出的资金总额',
        caliber: '单位：元，保留两位小数。当月所有转账、消费等转出交易金额汇总',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.9,
          timeliness: 98.0,
          issues: []
        },
        sampleData: ['8500.00', '10200.00', '3500.00'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.STAT_DATA',
        sourceSystem: '零售业务系统'
      },
      {
        id: 'c14',
        name: '存款时点余额',
        code: 'DEPOSIT_BALANCE',
        definition: '该客户代发账户在统计时点的存款余额',
        caliber: '单位：元，保留两位小数。统计截止日的账户余额',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.5,
          issues: []
        },
        sampleData: ['45200.00', '28300.00', '125600.00'],
        updateFrequency: 'T+1',
        sourceTable: 'PAYROLL.STAT_DATA',
        sourceSystem: '零售业务系统'
      }
    ]
  },
  'retail-deposit': {
    id: 'retail-deposit',
    name: '对公大额存款变动情况',
    description: '对公客户大额存款余额变动日报，支持按客户、机构、管户经理维度分析，包含机构、客户、交易及存款指标',
    tableCount: 6,
    recordCount: '35 万+',
    updateFrequency: 'T+1 每日更新',
    owner: '公司金融部',
    contact: '李四 (分机：8002)',
    fields: [
      {
        id: 'f1',
        name: '支行名称',
        code: 'SUBBRANCH_NAME',
        definition: '对公存款账户开户支行的标准名称',
        caliber: '支行标准名称，与机构信息表一致',
        dataType: 'string',
        length: 50,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.9,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['东风支行', '广州芳村支行', '逢源支行'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.DEPOSIT_DAILY',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f2',
        name: '分行名称',
        code: 'BRANCH_NAME',
        definition: '对公存款账户所属分行的标准名称',
        caliber: '分行标准名称，与机构信息表一致',
        dataType: 'string',
        length: 50,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['广州分行', '佛山分行', '东莞分行'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.DEPOSIT_DAILY',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f3',
        name: '客户名称',
        code: 'CUST_NAME',
        definition: '对公存款客户的法定全称',
        caliber: '与营业执照上的名称一致',
        dataType: 'string',
        length: 200,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.8,
          timeliness: 98.0,
          issues: ['企业更名后存在少量未及时更新']
        },
        sampleData: ['广州天河科技有限公司', '深圳南山区投资有限公司', '北京朝阳金融科技有限公司'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.DEPOSIT_DAILY',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f4',
        name: '跨行最大转入交易金额对手',
        code: 'MAX_IN_COUNTERPARTY',
        definition: '统计期内与该客户发生最大单笔转入交易的交易对手名称',
        caliber: '按统计期内单笔转入交易金额最大值对应的对手方名称',
        dataType: 'string',
        length: 200,
        nullable: true,
        quality: {
          completeness: 95.0,
          accuracy: 97.0,
          timeliness: 98.0,
          issues: ['部分跨行交易对手名称可能显示为银联或网银']
        },
        sampleData: ['广州天河科技有限公司', '深圳南山区投资有限公司'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.TRANS_DETAIL',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f5',
        name: '跨行最大转出交易金额对手',
        code: 'MAX_OUT_COUNTERPARTY',
        definition: '统计期内与该客户发生最大单笔转出交易的交易对手名称',
        caliber: '按统计期内单笔转出交易金额最大值对应的对手方名称',
        dataType: 'string',
        length: 200,
        nullable: true,
        quality: {
          completeness: 95.0,
          accuracy: 97.0,
          timeliness: 98.0,
          issues: ['部分跨行交易对手名称可能显示为银联或网银']
        },
        sampleData: ['佛山南海贸易有限公司', '东莞东城商贸有限公司'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.TRANS_DETAIL',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f6',
        name: '存款余额',
        code: 'DEPOSIT_BALANCE',
        definition: '对公存款账户在某一时点的资金余额',
        caliber: '单位：万元，保留两位小数。正常余额为正数',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.5,
          issues: []
        },
        sampleData: ['1,250.00', '860.00', '2,100.00'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.DEPOSIT_DAILY',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f7',
        name: '比上日',
        code: 'CHANGE_VS_PREV_DAY',
        definition: '存款余额与上一个工作日相比的变化量',
        caliber: '单位：万元，保留两位小数。正数表示增加，负数表示减少',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.5,
          issues: []
        },
        sampleData: ['+50.00', '-30.00', '+1,200.00'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.DEPOSIT_DAILY',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f8',
        name: '跨行转入金额',
        code: 'INTERBANK_IN_AMT',
        definition: '统计期内从其他银行转入的金额合计',
        caliber: '单位：万元，保留两位小数。按跨行转入交易汇总',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 99.5,
          accuracy: 99.8,
          timeliness: 98.0,
          issues: []
        },
        sampleData: ['180.00', '200.00', '350.00'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.TRANS_DETAIL',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f9',
        name: '跨行转出金额',
        code: 'INTERBANK_OUT_AMT',
        definition: '统计期内转出到其他银行的金额合计',
        caliber: '单位：万元，保留两位小数。按跨行转出交易汇总',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 99.5,
          accuracy: 99.8,
          timeliness: 98.0,
          issues: []
        },
        sampleData: ['120.00', '150.00', '80.00'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.TRANS_DETAIL',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f10',
        name: '跨行最大转入交易金额',
        code: 'MAX_IN_AMT',
        definition: '统计期内单笔最大的转入交易金额',
        caliber: '单位：万元，保留两位小数。按转入交易中金额最大值',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['150.00', '120.00', '280.00'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.TRANS_DETAIL',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f11',
        name: '跨行最大转出交易金额',
        code: 'MAX_OUT_AMT',
        definition: '统计期内单笔最大的转出交易金额',
        caliber: '单位：万元，保留两位小数。按转出交易中金额最大值',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['85.00', '95.00', '60.00'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.TRANS_DETAIL',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f12',
        name: '跨行最大转入交易金额对手行',
        code: 'MAX_IN_BANK',
        definition: '统计期内与该客户发生最大单笔转入交易的对手方开户银行名称',
        caliber: '按统计期内单笔转入交易金额最大值对应的对手方开户银行全称',
        dataType: 'string',
        length: 200,
        nullable: true,
        quality: {
          completeness: 95.0,
          accuracy: 97.0,
          timeliness: 98.0,
          issues: ['部分跨行交易对手行名称可能因联行号解析不完整而显示不全']
        },
        sampleData: ['中国工商银行广州天河支行', '广东华兴银行股份有限公司广州分行', '中国建设银行广州市越秀支行'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.TRANS_DETAIL',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'f13',
        name: '跨行最大转出交易金额对手行',
        code: 'MAX_OUT_BANK',
        definition: '统计期内与该客户发生最大单笔转出交易的对手方开户银行名称',
        caliber: '按统计期内单笔转出交易金额最大值对应的对手方开户银行全称',
        dataType: 'string',
        length: 200,
        nullable: true,
        quality: {
          completeness: 95.0,
          accuracy: 97.0,
          timeliness: 98.0,
          issues: ['部分跨行交易对手行名称可能因联行号解析不完整而显示不全']
        },
        sampleData: ['中国农业银行深圳福田支行', '中国招商银行广州分行', '广东华兴银行股份有限公司佛山分行'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.TRANS_DETAIL',
        sourceSystem: '对公业务系统'
      }
    ]
  },
  // 授信风险板块 - 五级分类
  'risk-classification': {
    id: 'risk-classification',
    name: '五级分类',
    description: '风险资产五级分类管理，包括正常、关注、次级、可疑、损失五类资产的认定、统计和监测',
    tableCount: 8,
    recordCount: '30 万+',
    updateFrequency: 'T+1 每日更新',
    owner: '风险管理部',
    contact: '李四 (分机：8003)',
    fields: [
      {
        id: '1',
        name: '资产分类代码',
        code: 'ASSET_CLASS_CODE',
        definition: '风险资产五级分类的代码标识，用于区分不同类别的风险资产',
        caliber: '5 级分类代码：01-正常，02-关注，03-次级，04-可疑，05-损失',
        dataType: 'string',
        length: 2,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.9,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['01', '02', '03'],
        updateFrequency: '实时',
        sourceTable: 'RISK.ASSET_CLASS',
        sourceSystem: '风险管理系统'
      },
      {
        id: '2',
        name: '分类名称',
        code: 'CLASS_NAME',
        definition: '风险资产五级分类的中文名称',
        caliber: '正常、关注、次级、可疑、损失',
        dataType: 'string',
        length: 10,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 100.0,
          issues: []
        },
        sampleData: ['正常', '关注', '次级'],
        updateFrequency: '实时',
        sourceTable: 'RISK.ASSET_CLASS',
        sourceSystem: '风险管理系统'
      },
      {
        id: '3',
        name: '资产余额',
        code: 'ASSET_BAL',
        definition: '该分类下风险资产的余额合计',
        caliber: '单位：元，保留两位小数。按借方余额统计',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.5,
          issues: []
        },
        sampleData: ['10000000.00', '5000000.00'],
        updateFrequency: '每日',
        sourceTable: 'RISK.ASSET_STAT',
        sourceSystem: '风险管理系统'
      },
      {
        id: '4',
        name: '分类日期',
        code: 'CLASS_DATE',
        definition: '对该笔资产进行风险分类的日期',
        caliber: '格式：YYYY-MM-DD，为风险分类认定日期',
        dataType: 'date',
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['2024-01-15', '2024-01-16'],
        updateFrequency: '每日',
        sourceTable: 'RISK.ASSET_CLASS',
        sourceSystem: '风险管理系统'
      },
      {
        id: '5',
        name: '分类依据',
        code: 'CLASS_BASE',
        definition: '对该笔资产进行风险分类的依据和理由',
        caliber: '根据借款人还款能力、还款记录、担保情况等因素综合判定',
        dataType: 'string',
        length: 500,
        nullable: true,
        quality: {
          completeness: 95.0,
          accuracy: 98.0,
          timeliness: 98.0,
          issues: ['部分历史资产分类依据记录不完整']
        },
        sampleData: ['借款人经营正常，能按时还本付息', '借款人出现暂时困难，但有能力通过正常经营偿还'],
        updateFrequency: '实时',
        sourceTable: 'RISK.ASSET_CLASS',
        sourceSystem: '风险管理系统'
      }
    ]
  },
  // 授信风险板块
  'risk-credit': {
    id: 'risk-credit',
    name: '授信用信信息',
    description: '涵盖客户授信额度、用信情况、授信审批、额度使用等全流程授信管理信息',
    tableCount: 15,
    recordCount: '50 万+',
    updateFrequency: 'T+1 每日更新',
    owner: '风险管理部',
    contact: '王五 (分机：8003)',
    fields: [
      {
        id: '1',
        name: '授信额度',
        code: 'CREDIT_LIMIT',
        definition: '银行批准给予客户的最高授信金额，客户可在此额度内申请用信',
        caliber: '单位：元，保留两位小数。包括综合授信额度、单项授信额度',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 99.8,
          accuracy: 99.9,
          timeliness: 98.0,
          issues: ['部分历史授信额度审批流程信息缺失']
        },
        sampleData: ['1000000.00', '5000000.00'],
        updateFrequency: '实时',
        sourceTable: 'CREDIT.CREDIT_INFO',
        sourceSystem: '信贷系统'
      },
      {
        id: '2',
        name: '已用额度',
        code: 'USED_LIMIT',
        definition: '客户已实际使用的授信金额',
        caliber: '单位：元，保留两位小数。包括贷款、承兑、担保等各类用信余额之和',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 99.9,
          accuracy: 99.9,
          timeliness: 98.0,
          issues: []
        },
        sampleData: ['500000.00', '2000000.00'],
        updateFrequency: '每日',
        sourceTable: 'CREDIT.CREDIT_USE',
        sourceSystem: '信贷系统'
      },
      {
        id: '3',
        name: '授信到期日',
        code: 'CREDIT_ENDDATE',
        definition: '授信额度的有效期限截止日期',
        caliber: '格式：YYYY-MM-DD，授信审批时确定的额度有效期截止日',
        dataType: 'date',
        nullable: false,
        quality: {
          completeness: 99.5,
          accuracy: 99.8,
          timeliness: 98.0,
          issues: ['少量历史数据授信到期日未录入']
        },
        sampleData: ['2025-12-31', '2026-06-30'],
        updateFrequency: '实时',
        sourceTable: 'CREDIT.CREDIT_INFO',
        sourceSystem: '信贷系统'
      }
    ]
  },
  // 对公金融板块
  'corporate-customer': {
    id: 'corporate-customer',
    name: '客户管理',
    description: '对公客户的基础信息、关联关系、集团客户信息、行业分类等',
    tableCount: 10,
    recordCount: '20 万+',
    updateFrequency: 'T+1 每日更新',
    owner: '公司金融部',
    contact: '赵六 (分机：8004)',
    fields: [
      {
        id: '1',
        name: '客户号',
        code: 'CORP_CUST_NO',
        definition: '银行为对公客户分配的唯一标识符',
        caliber: '10 位数字，以 02 开头',
        dataType: 'string',
        length: 10,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.9,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['0200001234', '0200005678'],
        updateFrequency: '实时',
        sourceTable: 'CORP.CUST_INFO',
        sourceSystem: 'ECIF 系统'
      },
      {
        id: '2',
        name: '客户名称',
        code: 'CORP_CUST_NAME',
        definition: '对公客户的法定全称',
        caliber: '与营业执照上的名称一致',
        dataType: 'string',
        length: 200,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.8,
          timeliness: 98.0,
          issues: ['企业更名后存在少量未及时更新']
        },
        sampleData: ['广州 XXX 有限公司', '深圳 XXX 科技有限公司'],
        updateFrequency: '实时',
        sourceTable: 'CORP.CUST_INFO',
        sourceSystem: 'ECIF 系统'
      },
      {
        id: '3',
        name: '统一社会信用代码',
        code: 'UNIFIED_SOCIAL_CODE',
        definition: '企业的统一社会信用代码，是企业的"身份证号"',
        caliber: '18 位，包含登记管理部门代码、机构类别代码、登记机关代码、主体标识码、校验码',
        dataType: 'string',
        length: 18,
        nullable: false,
        quality: {
          completeness: 99.5,
          accuracy: 99.7,
          timeliness: 98.0,
          issues: ['少量历史客户三证合一前数据未更新']
        },
        sampleData: ['91440101MA5CUKQT8X', '91440300MA5XXXXX1234'],
        updateFrequency: '实时',
        sourceTable: 'CORP.CUST_INFO',
        sourceSystem: 'ECIF 系统'
      }
    ]
  },
  // 对公金融板块 - 各机构对公客户存款主题
  'corporate-branch-deposit': {
    id: 'corporate-branch-deposit',
    name: '各机构存款情况统计',
    description: '广州银行下辖各机构对公及个人客户存款时点余额与年日均统计，包含统计日期、机构信息及存款指标',
    tableCount: 4,
    recordCount: '100 条+',
    updateFrequency: 'T+1 每日更新',
    owner: '资产负债部',
    contact: '李明 (分机：8010)',
    fields: [
      {
        id: 'd1',
        name: '统计日期',
        code: 'STAT_DATE',
        definition: '数据统计的截止日期',
        caliber: '格式：YYYY-MM-DD，取各业务系统日终批处理后的数据快照日期',
        dataType: 'date',
        nullable: false,
        quality: { completeness: 100.0, accuracy: 100.0, timeliness: 99.5, issues: [] },
        sampleData: ['2026-06-10', '2026-06-09', '2026-05-31'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.BRANCH_DEPOSIT_STAT',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'd2',
        name: '支行名称',
        code: 'SUBBRANCH_NAME',
        definition: '支行的标准名称',
        caliber: '支行标准名称，与机构信息表一致',
        dataType: 'string',
        length: 50,
        nullable: false,
        quality: { completeness: 100.0, accuracy: 99.9, timeliness: 99.0, issues: [] },
        sampleData: ['昌岗路支行', '赤岗支行', '敦和支行'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.BRANCH_DEPOSIT_STAT',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'd3',
        name: '分行名称',
        code: 'BRANCH_NAME',
        definition: '支行的所属分行标准名称',
        caliber: '分行标准名称，与机构信息表一致',
        dataType: 'string',
        length: 50,
        nullable: false,
        quality: { completeness: 100.0, accuracy: 100.0, timeliness: 99.0, issues: [] },
        sampleData: ['海珠中心支行'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.BRANCH_DEPOSIT_STAT',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'm1',
        name: '对公存款时点',
        code: 'CORP_DEPOSIT_POINT',
        definition: '统计日期该支行对公存款余额合计',
        caliber: '单位：万元，保留两位小数。统计截止日该支行所有对公存款账户余额合计',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: { completeness: 100.0, accuracy: 100.0, timeliness: 99.5, issues: [] },
        sampleData: ['1,256.80', '892.35', '2,100.00'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.BRANCH_DEPOSIT_STAT',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'm2',
        name: '个人存款时点',
        code: 'PERSONAL_DEPOSIT_POINT',
        definition: '统计日期该支行个人存款余额合计',
        caliber: '单位：万元，保留两位小数。统计截止日该支行所有个人存款账户余额合计',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: { completeness: 99.5, accuracy: 99.8, timeliness: 99.0, issues: [] },
        sampleData: ['356.20', '125.80', '580.00'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.BRANCH_DEPOSIT_STAT',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'm3',
        name: '对公存款年日均',
        code: 'CORP_DEPOSIT_AVG',
        definition: '该支行当年1月1日至统计日的对公存款日均余额',
        caliber: '单位：万元，保留两位小数。年日均 = 累计对公存款积数 / 当年累计天数',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: { completeness: 100.0, accuracy: 100.0, timeliness: 99.0, issues: [] },
        sampleData: ['1,180.50', '768.90', '1,850.00'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.BRANCH_DEPOSIT_STAT',
        sourceSystem: '对公业务系统'
      },
      {
        id: 'm4',
        name: '个人存款年日均',
        code: 'PERSONAL_DEPOSIT_AVG',
        definition: '该支行当年1月1日至统计日的个人存款日均余额',
        caliber: '单位：万元，保留两位小数。年日均 = 累计个人存款积数 / 当年累计天数',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: { completeness: 99.5, accuracy: 99.5, timeliness: 99.0, issues: [] },
        sampleData: ['298.60', '108.50', '520.00'],
        updateFrequency: 'T+1',
        sourceTable: 'CORP.BRANCH_DEPOSIT_STAT',
        sourceSystem: '对公业务系统'
      }
    ]
  },
  // 金融市场板块
  'market-bond': {
    id: 'market-bond',
    name: '债券',
    description: '银行投资的各类债券信息，包括国债、金融债、企业债、中票短融等',
    tableCount: 8,
    recordCount: '5 万+',
    updateFrequency: 'T+1 每日更新',
    owner: '金融市场部',
    contact: '钱七 (分机：8005)',
    fields: [
      {
        id: '1',
        name: '债券代码',
        code: 'BOND_CODE',
        definition: '债券在交易市场的唯一标识代码',
        caliber: '银行间市场 6 位数字，交易所市场 6 位数字',
        dataType: 'string',
        length: 10,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 100.0,
          issues: []
        },
        sampleData: ['200001', '102100001'],
        updateFrequency: '实时',
        sourceTable: 'MARKET.BOND_INFO',
        sourceSystem: '资金业务系统'
      },
      {
        id: '2',
        name: '债券名称',
        code: 'BOND_NAME',
        definition: '债券的中文全称',
        caliber: '按发行文件确定的债券全称',
        dataType: 'string',
        length: 200,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 99.9,
          timeliness: 100.0,
          issues: []
        },
        sampleData: ['20 国债 01', '21 国开 01'],
        updateFrequency: '实时',
        sourceTable: 'MARKET.BOND_INFO',
        sourceSystem: '资金业务系统'
      },
      {
        id: '3',
        name: '票面利率',
        code: 'COUPON_RATE',
        definition: '债券的票面年化利率',
        caliber: '百分比，保留 4 位小数。固定利率债券为发行时确定的利率，浮动利率债券为当期利率',
        dataType: 'decimal',
        length: 10,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.5,
          issues: []
        },
        sampleData: ['3.2500', '2.8500'],
        updateFrequency: '每日',
        sourceTable: 'MARKET.BOND_INFO',
        sourceSystem: '资金业务系统'
      }
    ]
  },
  // 分行特色板块
  'branch-personal': {
    id: 'branch-personal',
    name: '个人账户明细（含旧核心流水）',
    description: '个人客户账户交易流水明细，包含新旧核心系统切换前后的所有交易记录',
    tableCount: 25,
    recordCount: '5 亿+',
    updateFrequency: 'T+1 每日更新',
    owner: '分行科技部',
    contact: '孙八 (分机：8006)',
    fields: [
      {
        id: '1',
        name: '交易流水号',
        code: 'TXN_SEQ_NO',
        definition: '每笔交易的唯一标识号，用于追踪和查询交易',
        caliber: '20 位数字，包含日期、机构、顺序号等',
        dataType: 'string',
        length: 20,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.9,
          issues: []
        },
        sampleData: ['20240115000100000001', '20240115000200000002'],
        updateFrequency: '实时',
        sourceTable: 'TRANS.TXN_LOG',
        sourceSystem: '核心系统'
      },
      {
        id: '2',
        name: '交易日期',
        code: 'TXN_DATE',
        definition: '交易发生的日期',
        caliber: '格式：YYYY-MM-DD，为交易在核心系统记录的日期',
        dataType: 'date',
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.9,
          issues: []
        },
        sampleData: ['2024-01-15', '2024-01-16'],
        updateFrequency: '实时',
        sourceTable: 'TRANS.TXN_LOG',
        sourceSystem: '核心系统'
      },
      {
        id: '3',
        name: '交易金额',
        code: 'TXN_AMT',
        definition: '交易的金额，借方为正数，贷方为负数',
        caliber: '单位：元，保留两位小数。正数表示支出，负数表示收入',
        dataType: 'decimal',
        length: 18,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.9,
          issues: []
        },
        sampleData: ['1000.00', '-5000.00'],
        updateFrequency: '实时',
        sourceTable: 'TRANS.TXN_LOG',
        sourceSystem: '核心系统'
      },
      {
        id: '4',
        name: '交易对手',
        code: 'COUNTERPARTY',
        definition: '交易的对方账户名称或账号',
        caliber: '转账交易时为对方账户名称或账号，现金交易时为空或显示"现金"',
        dataType: 'string',
        length: 200,
        nullable: true,
        quality: {
          completeness: 95.0,
          accuracy: 97.0,
          timeliness: 99.0,
          issues: ['部分早期交易对手信息不完整', '跨行交易对手名称可能显示为银联或网银']
        },
        sampleData: ['张三', '6222000100010001234'],
        updateFrequency: '实时',
        sourceTable: 'TRANS.TXN_LOG',
        sourceSystem: '核心系统'
      }
    ]
  },
  // 监管报送板块
  'regulatory-east': {
    id: 'regulatory-east',
    name: 'east 数据核对',
    description: '银保监会 EAST5.0 系统报送数据，包含标准化监管数据',
    tableCount: 30,
    recordCount: '1000 万+',
    updateFrequency: '月度报送',
    owner: '合规管理部',
    contact: '周九 (分机：8007)',
    fields: [
      {
        id: '1',
        name: '报送批次号',
        code: 'REPORT_BATCH_NO',
        definition: '每次 EAST 报送的唯一标识号',
        caliber: '格式：EAST+ 年月 + 批次号',
        dataType: 'string',
        length: 20,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 100.0,
          issues: []
        },
        sampleData: ['EAST202401-001', 'EAST202402-001'],
        updateFrequency: '月度',
        sourceTable: 'EAST.BATCH_INFO',
        sourceSystem: 'EAST 报送系统'
      },
      {
        id: '2',
        name: '数据校验状态',
        code: 'DATA_CHECK_STAT',
        definition: 'EAST 数据校验的结果状态',
        caliber: '0-未校验，1-校验通过，2-校验失败，3-已报送',
        dataType: 'string',
        length: 1,
        nullable: false,
        quality: {
          completeness: 100.0,
          accuracy: 100.0,
          timeliness: 99.0,
          issues: []
        },
        sampleData: ['1', '3'],
        updateFrequency: '月度',
        sourceTable: 'EAST.CHECK_RESULT',
        sourceSystem: 'EAST 报送系统'
      }
    ]
  }
}
